import React, { useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { API_BASE_URL } from '@/config';
import { PageLoading } from '@/components/ui/loading';

/**
 * WorkOS redirects here with ?code=... after login.
 * We send the user to the backend to exchange the code and set the session cookie,
 * then the backend redirects to /.
 */
export default function CallbackPage() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const error = searchParams.get('error');

  useEffect(() => {
    if (error) return;
    if (code) {
      window.location.href = `${API_BASE_URL}/auth/callback?code=${encodeURIComponent(code)}`;
    } else {
      window.location.href = '/login?error=no_code';
    }
  }, [code, error]);

  if (error) {
    const message =
      error === 'no_code'
        ? 'No authorization code received.'
        : error === 'auth_failed'
          ? 'Sign-in failed. Please try again.'
          : 'Something went wrong. Please try again.';
    return (
      <div className="flex flex-col items-center justify-center min-h-screen gap-4 bg-nb-bg p-8">
        <p className="text-sm text-muted-foreground text-center">{message}</p>
        <Link to="/login" className="text-sm text-primary hover:underline">
          Back to sign in
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-nb-bg">
      <PageLoading message="Signing you in…" />
    </div>
  );
}
